import {AccessArea} from 'Common/permissions/AccessArea';
import {Role} from 'Common/permissions/Role';
import {BrowserOrServerId} from 'Browser/BrowserId';

export class AdminRole<Id extends BrowserOrServerId> extends Role<Id>
{
	constructor()
	{
		super('admin');
	}

	public toJson()
	{
		return {
			type: this.name
		};
	}

	public topAccess(): AccessArea
	{
		return new AccessArea('admin');
	}

	public canAccessArea(_area:AccessArea)
	{
		return true;
	}

	public amManager(_artistId: BrowserOrServerId)
	{
		return true;
	}
}

